module.exports = __webpack_public_path__ + "img/card-brand-discover.721f5334.png";